<template>
  <div>
    <div id="zhanbi"></div>
  </div>
</template>
<script>
import echarts from "echarts";
export default {
  props: ["zhanbiList"],
  data() {
    return {};
  },
  watch: {
    zhanbiList(yuqingZhanbiDatas) {
      if (yuqingZhanbiDatas) {
        // console.log(yuqingZhanbiDatas);
        // let color = ["#1B8EFF", "#5CDBD3", "#F4222E", "#9254DE"];
        // let arrName = [];
        // let arrValue = [];
        // let sum = 0;
        // let pieSeries = [],
        //   lineYAxis = [];
        // let chartData = [
        //   {
        //     name: "敏感",
        //     value: yuqingZhanbiDatas.negativeCount, //132,
        //     unit: "条"
        //   },
        //   {
        //     name: "非敏感",
        //     value: yuqingZhanbiDatas.positiveCount, //421,
        //     unit: "条"
        //   }
        // ];
        let mingangNewsDatasTrue=0
        let mingangNewsDatasFalse=0
        if(yuqingZhanbiDatas.negativeCount==0 && yuqingZhanbiDatas.positiveCount==0){
        mingangNewsDatasTrue=0
        mingangNewsDatasFalse=0
        }else{
        mingangNewsDatasTrue= yuqingZhanbiDatas.negativeCount/(yuqingZhanbiDatas.negativeCount+yuqingZhanbiDatas.positiveCount)
        mingangNewsDatasFalse=yuqingZhanbiDatas.positiveCount/(yuqingZhanbiDatas.negativeCount+yuqingZhanbiDatas.positiveCount)
        }
        // chartData.forEach((v, i) => {
        //   arrName.push(v.name);
        //   arrValue.push(v.value);
        //   sum = sum + v.value;
        // });
        // chartData.forEach((v, i) => {
        //   pieSeries.push({
        //     name: "舆情占比",
        //     type: "pie",
        //     clockWise: false,
        //     hoverAnimation: true,
        //     radius: [85 - i * 20 + "%", 77 - i * 20 + "%"],
        //     center: ["50%", "50%"], //数据环
        //     label: {
        //       show: false
        //     },
        //     data: [
        //       {
        //         value: v.value * 0.75, //v.value
        //         name: v.name
        //       },
        //       {
        //         value: sum - v.value * 0.75, //sum - v.value
        //         name: "",
        //         itemStyle: {
        //           color: "rgba(0,0,0,0)"
        //         }
        //       }
        //     ]
        //   });
        //   pieSeries.push({
        //     name: "",
        //     type: "pie",
        //     silent: true,
        //     z: 1,
        //     clockWise: false, //顺时加载
        //     hoverAnimation: true, //鼠标移入变大
        //     radius: [85 - i * 20 + "%", 77 - i * 20 + "%"],
        //     center: ["50%", "50%"], //背景环的位置
        //     label: {
        //       show: false
        //     },
        //     data: [
        //       {
        //         value: 7.5,
        //         itemStyle: {
        //           color: "#E3F0FF"
        //         }
        //       },
        //       {
        //         value: 2.5,
        //         name: "",
        //         itemStyle: {
        //           color: "rgba(0,0,0,0)"
        //         }
        //       }
        //     ]
        //   });
        //   v.percent =
        //     ((v.value / sum) * 100).toFixed(1) == "NaN"
        //       ? 0 + "%"
        //       : ((v.value / sum) * 100).toFixed(1) + "%";
        //   lineYAxis.push({
        //     value: i,
        //     textStyle: {
        //       rich: {
        //         circle: {
        //           color: color[i],
        //           padding: [0, 5]
        //         }
        //       }
        //     }
        //   });
        // });
        // let yuqingZhanbiOption = {
        //   backgroundColor: "#fff",
        //   color: color,
        //   grid: {
        //     //指示线文字的位置设置
        //     top: "4.5%", //20%
        //     bottom: "75%", //54%
        //     left: "48%",
        //     containLabel: false
        //   },
        //   yAxis: [
        //     {
        //       type: "category",
        //       inverse: true,
        //       axisLine: {
        //         show: false
        //       },
        //       axisTick: {
        //         show: false
        //       },
        //       axisLabel: {
        //         formatter: function(params) {
        //           let item = chartData[params];
        //           return (
        //             "{line|}{circle|●}{name|" +
        //             item.name +
        //             "}{bd||}{percent|" +
        //             item.percent +
        //             "}{value|" +
        //             item.value +
        //             "}{unit|条}"
        //           );
        //         },
        //         interval: 0,
        //         inside: true,
        //         textStyle: {
        //           color: "#333",
        //           fontSize: 14,
        //           rich: {
        //             line: {
        //               width: 20,
        //               height: 10,
        //               backgroundColor: {
        //                 image:
        //                   "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAM8AAAAOBAMAAAB6G1V9AAAAD1BMVEX////Kysrk5OTj4+TJycoJ0iFPAAAAG0lEQVQ4y2MYBaNgGAMTQQVFOiABhlEwCugOAMqzCykGOeENAAAAAElFTkSuQmCC"
        //               }
        //             },
        //             name: {
        //               color: "#666",
        //               fontSize: 10
        //             },
        //             bd: {
        //               color: "#ccc",
        //               padding: [0, 5],
        //               fontSize: 10
        //             },
        //             percent: {
        //               color: "#333",
        //               fontSize: 10
        //             },
        //             value: {
        //               color: "#333",
        //               fontSize: 10,
        //               fontWeight: 500,
        //               padding: [0, 0, 0, 10]
        //             },
        //             unit: {
        //               fontSize: 10
        //             }
        //           }
        //         },
        //         show: true
        //       },
        //       data: lineYAxis
        //     }
        //   ],
        //   xAxis: [
        //     {
        //       show: false
        //     }
        //   ],
        //   series: pieSeries
        // };

        var placeHolderStyle = {
          normal: {
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            color: "rgba(0,0,0,0)",
            borderWidth: 0
          },
          emphasis: {
            color: "rgba(0,0,0,0)",
            borderWidth: 0
          }
        };
        var dataStyle = {
          normal: {
            formatter: "{c}%",
            position: "center",
            show: true,
            textStyle: {
              fontSize: "20",
              fontWeight: "normal",
              color: "#34374E"
            }
          }
        };
        var mingangOption = {
          backgroundColor: "#fff",
          title: [
            {
              text: "敏 感",
              left: "27.3%",
              top: "75%",
              textAlign: "center",
              textStyle: {
                fontWeight: "normal",
                fontSize: "16",
                color: "#F4222E",
                textAlign: "center"
              }
            },
            {
              text: "非敏感",
              left: "74.5%",
              top: "75%",
              textAlign: "center",
              textStyle: {
                color: "#5B97FF",
                fontWeight: "normal",
                fontSize: "16",
                textAlign: "center"
              }
            }
          ],

          //第一个图表
          series: [
            {
              type: "pie",
              hoverAnimation: false, //鼠标经过的特效
              radius: ["33%", "44%"],
              center: ["28%", "50%"],
              startAngle: 225,
              labelLine: {
                normal: {
                  show: false
                }
              },
              label: {
                normal: {
                  position: "center"
                }
              },
              data: [
                {
                  value: 100,
                  itemStyle: {
                    normal: {
                      color: "#FAD4D7"
                    }
                  }
                },
                {
                  value: 35,
                  itemStyle: placeHolderStyle
                }
              ]
            },
            //上层环形配置
            {
              type: "pie",
              hoverAnimation: false, //鼠标经过的特效
              radius: ["33%", "44%"],
              center: ["28%", "50%"],
              startAngle: 225,
              labelLine: {
                normal: {
                  show: false
                }
              },
              label: {
                normal: {
                  position: "center"
                }
              },
              data: [
                {
                  value: Math.round(mingangNewsDatasTrue * 100), //敏感的数据值
                  itemStyle: {
                    normal: {
                      color: "#F4222E",
                      
                    }
                  },
                  label: dataStyle
                },
                {
                  value: 35,
                  itemStyle: placeHolderStyle
                }
              ]
            },

            //第二个图表
            {
              type: "pie",
              hoverAnimation: false,
              radius: ["33%", "44%"],
              center: ["75%", "50%"],
              startAngle: 225,
              labelLine: {
                normal: {
                  show: false
                }
              },
              label: {
                normal: {
                  position: "center"
                }
              },
              data: [
                {
                  value: 100,
                  itemStyle: {
                    normal: {
                      color: "#EBF3FC"
                    }
                  }
                },
                {
                  value: 35,
                  itemStyle: placeHolderStyle
                }
              ]
            },

            //上层环形配置
            {
              type: "pie",
              hoverAnimation: false,
              radius: ["33%", "44%"],
              center: ["75%", "50%"],
              startAngle: 225,
              labelLine: {
                normal: {
                  show: false
                }
              },
              label: {
                normal: {
                  position: "center"
                }
              },
              data: [
                {
                  value: Math.round(mingangNewsDatasFalse * 100), //非敏感的数据执
                  itemStyle: {
                    normal: {
                      color: "#5B97FF"
                    }
                  },
                  label: dataStyle
                },
                {
                  value: 35,
                  itemStyle: placeHolderStyle
                }
              ]
            }
          ]
        };

        var chartDom = document.getElementById("zhanbi");
        var myChart = echarts.init(chartDom);

        mingangOption && myChart.setOption(mingangOption);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
#zhanbi {
  width: 100%;
  height: 100%;
}
</style>